import { useCallback } from "react";
import useMessageStore from "../stores/message-store";
import useApi from "./use-api";


const useFileDownload = () => {
    const {getFileRequest} = useApi();
    const addToast = useMessageStore(state => state.addToast);

    /**
     * Downloads a file from and enpoint.
     * @param {Object} fileData - The Data to send to the API (id's, keys, etc.).
     * @param {string} endPoint - The Endpoint key corresponding to an endpoint in the endpoint map.
     * @param {string} fileName - The Name of the downloaded file.
    */
    const downloadFile = useCallback(async (fileData,endPoint,fileName) => {
        const response = await getFileRequest(endPoint,fileData);

        if(response.status === 200){
            const url = window.URL.createObjectURL(new Blob([response.data]));

            const link = document.createElement('a');

            link.href = url;

            link.setAttribute('download',fileName);

            document.body.appendChild(link);

            link.click();

            link.parentNode.removeChild(link);
        }
        else{
            addToast(
                {
                    id: Math.random(),
                    body: "An error occured when downloading the requested file.",
                    autoHide: true,
                    errorFlag: true,
                    timestamp: Date.now() - 1000
                }
            )
        }
    }, []);

    return downloadFile;
}

export default useFileDownload;